import * as React from "react";
import { cn } from "../../lib/utils";

export interface EyebrowProps extends React.HTMLAttributes<HTMLSpanElement> {}

/**
 * Small-caps section label. The visual eyebrow above titles.
 */
const Eyebrow = React.forwardRef<HTMLSpanElement, EyebrowProps>(
	({ className, ...props }, ref) => {
		return (
			<span
				ref={ref}
				className={cn(
					"text-[10px] font-medium uppercase tracking-[0.12em] text-gray-500 dark:text-gray-500",
					"[font-feature-settings:'ss01']",
					className,
				)}
				{...props}
			/>
		);
	},
);
Eyebrow.displayName = "Eyebrow";

export { Eyebrow };
